import ResponsiveHeader from '@/components/ResponsiveHeader';
import { Stack } from 'expo-router';

/**
 * Post-purchase welcome page. Wears the standard app header (logo + nav) so
 * the buyer can wander off, but no back control: there is nothing to go back
 * to — WordPress sent them here straight from checkout.
 */
export default function WelcomeStackLayout() {
  return (
    <Stack
      screenOptions={{
        animation: 'default',
        header: ({ options }) => (
          <ResponsiveHeader
            title={(options.title as string) || ''}
            showBack={false}
            showBookmark={false}
            navItems={[
              { label: 'Explore', href: '/explore' },
              { label: 'Live', href: '/live' },
              { label: 'The Hang', href: '/library' },
            ]}
          />
        ),
      }}
    >
      <Stack.Screen name="index" options={{ title: '' }} />
    </Stack>
  );
}
